import { render, staticRenderFns } from "./OnlineUsersLocal.vue?vue&type=template&id=1b5bd7ea&scoped=true&lang=pug&"
import script from "./OnlineUsersLocal.vue?vue&type=script&lang=js&"
export * from "./OnlineUsersLocal.vue?vue&type=script&lang=js&"
import style0 from "./OnlineUsersLocal.vue?vue&type=style&index=0&id=1b5bd7ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5bd7ea",
  null
  
)

export default component.exports